import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

type AiOperation = 'identify' | 'generate' | 'keywords' | 'nlq' | 'comps' | 'appraise' | 'reply';

const METHODOLOGY: Record<AiOperation, string> = {
  identify:
    'Visual AI analysis of uploaded image. Identifies category, era, materials, and estimated value based on visual features compared to known antiques and collectibles.',
  generate:
    'AI-generated marketplace listing optimized for search visibility. Title targets keywords, description follows platform-specific length guidelines, features highlight key selling points.',
  keywords:
    'AI-extracted search terms optimized for marketplace discoverability. Prioritizes era, style, material, and category terms that buyers search for.',
  nlq: 'AI-powered natural language analysis of your inventory and marketplace data. Synthesizes available metrics and context into actionable insights.',
  comps:
    'AI-simulated comparable sales based on item attributes and recent market trends. Prices reflect realistic resale values — verify against actual sold listings before relying on pricing decisions.',
  appraise:
    'AI appraisal based on visual analysis of photos combined with era, materials, and condition context. Value estimates use comparable sales patterns — this is not a certified appraisal.',
  reply:
    'AI-generated reply based on buyer message context, platform norms, and professional reseller communication patterns. Review before sending.',
};

interface AiTooltipProps {
  operation: AiOperation;
  className?: string;
}

export function AiTooltip({ operation, className }: AiTooltipProps) {
  const text = METHODOLOGY[operation] ?? 'AI-generated content.';

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={`inline-flex cursor-help items-center ${className ?? ''}`}>
          <Info className="h-3.5 w-3.5 text-muted-foreground transition-colors hover:text-foreground" />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[280px] text-xs">
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  );
}

export { type AiOperation };
